import { Navigate, Outlet } from "react-router";
import { useAuth } from "./AuthProvider";
import { USER_ROLES } from "./userRoles";

const AdminGuard = () => {
  const { role, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (role !== USER_ROLES.admin) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default AdminGuard;
